import { Text, type TextProps } from "@chakra-ui/react";

function Overline({ children, ...props }: TextProps) {
  return (
    <Text
      fontFamily="mono"
      fontSize="xs"
      textTransform="uppercase"
      letterSpacing="0.5px"
      {...props}
    >
      { children }
    </Text>
  );
}

export default Overline;
